export var HEADER_NAVIGATION_CLASS_PREFIX = 'HeaderNavigation';
export var headerNavigationRoot = 'HeaderNavigationRoot';
export var headerNavigationItemRoot = 'HeaderNavigationItemRoot';